/**
 *
 */
import * as React from 'react';
import {observer} from "mobx-react";
import {IResDay} from "shared/ResDay";
import {DateTimeFormat, DateTimeHelpers} from "shared/DateTimeHelpers";
import {ResData} from "components/reservations/ResData";

interface Props {
  resDays:IResDay[];
  onClickResDay:(resDay:IResDay)=>void;
  isRescheduling:boolean;
  uiWordSlot:string;
  timezone:string;
}

@observer
export class AvailableDays extends React.Component<Props> {
  render() {
    return (
      <div className={"available-days"}>
        {this.props.isRescheduling && <p>Select a day to reschedule your {this.props.uiWordSlot.toLowerCase()}:</p>}
        <div className="white-button-stack">
          {this.props.resDays.map(d=> <AvailableDayButton key={d._id} resDay={d} onClickResDay={this.props.onClickResDay} /> )}
        </div>
      </div>
    );
  }
}

interface Props_AvailableDayButton {
  resDay:IResDay;
  onClickResDay:(resDay:IResDay)=>void;
}


const AvailableDayButton = (props:Props_AvailableDayButton) => {
  const slots =  ResData.availableSlotsForResDay(props.resDay);
  const noneAvailable = (0===slots.length);

  if(noneAvailable) {
    return (
      <button
        className="white full disabled"
      >
        <span>{DateTimeHelpers.format(props.resDay.day, DateTimeFormat.WEEKDAY_ABREV_MMDD_UI, "America/New_York")}</span>
        <span className={"none-available"}>None available</span>
      </button>
    );
  } else {
    return (
      <button
        className="white full"
        onClick={()=>{props.onClickResDay(props.resDay);}}
      >
        {DateTimeHelpers.format(props.resDay.day, DateTimeFormat.WEEKDAY_ABREV_MMDD_UI, "America/New_York")}
      </button>
    );
  }


}

